import { Box, Flex, Text } from '@chakra-ui/react'
import { medecinBars } from '../constants'
import Itembar from '../Itembar'

const MedecinSideBars = () => {
  return (
    <Box>
        {/* <Flex flexDirection='column' my={4} gap={4} >
            {medecinBars.slice(0,1).map((bar,index)=>(
                <Itembar type='medecin' key={index} bar={bar} />
            ))}
        </Flex> */}
        <Text color='gray' mt={4} >Events</Text>
        <Flex flexDirection='column' my={4} gap={4} >
            {medecinBars.slice(1).map((bar,index)=>(
                <Itembar type='medecin' key={index} bar={bar} />
            ))}
        </Flex>
    </Box>
  )
}

export default MedecinSideBars